//import CoolenWordGroupResultArea from "@/pages/comp/coolen/word_group/common/group_result";
import { useState, useRef, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import { useSelector, useDispatch } from 'react-redux';
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import GroupDetArea from "./area/group_det";

function CoolenWordGroupResultArea(props:any){
  let myProps = {
    g_par_id:"",
    g_par_seq:"",
    stu_seq:"",
    is_show_close_btn: true,
    close_btn_text: "닫기",
    on_click_close: () => { },
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const [pre_data,set_pre_data] = useState<any>({});

  useEffect(()=>{
    get_pre_study_data_by_ajax({});
  },[user]);

  const get_pre_study_data_by_ajax=(inData:any)=>{
    let opt_obj={
      user_seq:myProps.stu_seq,
      coolen_study_par_id:myProps.g_par_id,
      coolen_study_par_seq:myProps.g_par_seq,
      ...inData
    };

    if(strFunc.is_empty(opt_obj.user_seq)
      ||strFunc.is_empty(opt_obj.coolen_study_par_id)){
        alert("필수 정보가 누락되었습니다.");
        myProps.on_click_close();
        return false;
    }
    let pre_s_start_date=DateFunc.get_date_format(DateFunc.get_change_date(new Date(),'day',-21),"Y-m-d");
    let form_json_data:any={
      stu_seq:opt_obj.user_seq,
      coolen_study_par_id:opt_obj.coolen_study_par_id,
      coolen_study_par_seq:opt_obj.coolen_study_par_seq,
      pre_s_start_date:pre_s_start_date,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/coolen/save_study/get_study_data', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_pre_data(response.data["data"]);
        } else {
          alert("조회중 오류." + response.data["msg"]);
        }
      });
  };

  let study_title_str="";
  if(pre_data["study_title_info"]){
    study_title_str=pre_data["study_title_info"]["a_title"];
  }

  return (
    <div>
      <h1>{study_title_str}</h1>
      <div>
        <GroupDetArea
          pre_data={pre_data}
        ></GroupDetArea>
      </div>
    </div>
  );
}

export default CoolenWordGroupResultArea;